import React from 'react';

import PropTypes from 'prop-types';

import { InputAdornmentPosition } from 'ui-components/components/number-input/input-adornment-position';

import { UnitPosition, UnitPositionPropType } from '../../../enums/units/unit-position';
import { FormattedMessagePropType } from '../../../prop-types/intl';

import style from './unit-adornment.module.css';

export const convertUnitPositionToAdornmentPosition = (unitPosition) => {
  if (unitPosition === UnitPosition.InsideStart) {
    return InputAdornmentPosition.Start;
  }

  if (unitPosition === UnitPosition.InsideEnd) {
    return InputAdornmentPosition.End;
  }

  return undefined;
};

export const UnitAdornment = ({ unitPosition = UnitPosition.InsideStart, unitLabel, id, labelFor }) => {
  const showAdornment = !!convertUnitPositionToAdornmentPosition(unitPosition);

  return (
    showAdornment && (
      <label className={style['unit-adornment']} htmlFor={labelFor} id={id}>
        {unitLabel}
      </label>
    )
  );
};

UnitAdornment.propTypes = {
  unitPosition: UnitPositionPropType,
  unitLabel: PropTypes.oneOfType([FormattedMessagePropType, PropTypes.node]).isRequired,
  id: PropTypes.string,
  labelFor: PropTypes.string,
};
